import { Component, registerComponent } from 'js/component.js';
import { ROCKWELL_BREAKPOINTS_MAX_EM } from 'js/constants.js';
import gsap from 'gsap';

const componentName = 'quick-links';

/**
 * Quick Links
 */
class QuickLinks extends Component {

    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        mobileHeader: this.element.querySelector(`.${componentName}__mobile-header`),
        wrapper: this.element.querySelector(`.${componentName}__wrapper`),
    };

    matchMobile = window.matchMedia(`(max-width: ${ROCKWELL_BREAKPOINTS_MAX_EM.DESKTOP}em)`);

    /**
     * Initialize Mobile Dropdown
     */
    initMobileDropdown = () => {
        if (this.matchMobile.matches) {
            gsap.set(this.elements.wrapper, { display: 'none' });
        } else {
            gsap.set(this.elements.wrapper, {
                display: '',
                height: 'auto'
            });
        }
    };

    /**
     * Add Homepage Class to Container
     */
    initHomepageClass = () => {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.element.classList.add('homepage-design');
        }
    };

    /**
     * GSAP slideUp animation
     */
    slideUp = (element, duration = 0.3) => {
        gsap.to(element, {
            height: 0,
            duration: duration,
            ease: 'power2.out',
            onComplete: () => {
                gsap.set(element, {
                    display: 'none',
                    height: 'auto'
                });
            }
        });
    };

    /**
     * GSAP slideDown animation
     */
    slideDown = (element, duration = 0.3) => {
        gsap.set(element, {
            display: 'block',
            height: 'auto',
            overflow: 'hidden'
        });

        const height = element.offsetHeight;
        gsap.set(element, { height: 0 });

        gsap.to(element, {
            height: height,
            duration: duration,
            ease: 'power2.out',
            onComplete: () => {
                gsap.set(element, {
                    height: 'auto',
                    overflow: ''
                });
            }
        });
    };

    /**
     * Handle Dropdown Open/Close
     */
    toggleMobileLinks = () => {
        if (this.elements.mobileHeader.classList.contains('active')) {
            this.elements.mobileHeader.classList.remove('active');
            this.slideUp(this.elements.wrapper);
        } else {
            this.elements.mobileHeader.classList.add('active');
            this.slideDown(this.elements.wrapper);
        }
    };

    addEventListeners = () => {
        this.elements.mobileHeader.addEventListener('click', this.toggleMobileLinks);
        this.matchMobile.addEventListener('change', this.initMobileDropdown);
    };

    /**
     * Initialize Component
     */
    init() {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.addEventListeners();
            this.initMobileDropdown();
            this.initHomepageClass();
        }
    }
}

registerComponent(`.${componentName}`, QuickLinks);
